// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { hoursToSeconds as fn } from "../hoursToSeconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const hoursToSeconds = convertToFP(fn, 1);

// Fallback for modularized imports:
export default hoursToSeconds;
